import { AntdFormInput, AntdFormPassword } from '@/components/AntdForm/AntdFormInput.tsx';
import {
  AntdFormDatePicker,
  AntdFormDayjsPicker,
} from '@/components/AntdForm/AntdFormDatePicker.tsx';
import { AntdFormItem } from '@/components/AntdForm/AntdFormItem.tsx';
import { AntdFormTextArea } from '@/components/AntdForm/AntdFormTextArea.tsx';
import {
  AntdFormCurrency,
  AntdFormMonth,
  AntdFormSelect,
} from '@/components/AntdForm/AntdFormSelect.tsx';
import { AntdFormNumberInput } from '@/components/AntdForm/AntdFormNumberInput.tsx';
import { AntdFormTimeDurationInput } from '@/components/AntdForm/AntdFormTimeDurationInput.tsx';
import { AntdFormBoolean } from '@/components/AntdForm/AntdFormBoolean.tsx';
import { AntdFormSwitch } from '@/components/AntdForm/AntdFormSwitch.tsx';
import { AntdFormMoneyInput } from '@/components/AntdForm/AntdFormMoneyInput.tsx';
import { AntdFormExcelInput } from '@/components/AntdForm/AntdFormExcelInput.tsx';
import { AntdFormComboBox } from '@/components/AntdForm/AntdFormComboBox.tsx';
import { AntdFormYearPicker } from '@/components/AntdForm/AntdFormYearPicker.tsx';
import { AntdFormCheckbox } from '@/components/AntdForm/AntdFormCheckbox.tsx';
import { AntdFormStarRate } from '@/components/AntdForm/AntdFormStarRate.tsx';
import {
  AntdFormSection,
  AntdFormSectionWrapper,
  AntdFormWrapper,
} from '@/components/AntdForm/AntdFormWrapper.tsx';
import { AntdFormCopyButton } from '@/components/AntdForm/AntdFormCopyButton.tsx';
import { AntdFormRadio } from '@/components/AntdForm/AntdFormRadio.tsx';
import { AntdFormAutoComplete } from '@/components/AntdForm/AntdFormAutoComplete.tsx';

export const AntdForm = {
  FormWrapper: AntdFormWrapper,
  SectionWrapper: AntdFormSectionWrapper,
  Section: AntdFormSection,
  Item: AntdFormItem,
  Input: AntdFormInput,
  Password: AntdFormPassword,
  TextArea: AntdFormTextArea,
  NumberInput: AntdFormNumberInput,
  MoneyInput: AntdFormMoneyInput,
  Select: AntdFormSelect,
  Currency: AntdFormCurrency,
  Year: AntdFormYearPicker,
  Month: AntdFormMonth,
  Checkbox: AntdFormCheckbox,
  Radio: AntdFormRadio,
  ComboBox: AntdFormComboBox,
  Boolean: AntdFormBoolean,
  Switch: AntdFormSwitch,
  TimeDuration: AntdFormTimeDurationInput,
  DatePicker: AntdFormDatePicker,
  DayjsPicker: AntdFormDayjsPicker,
  ExcelInput: AntdFormExcelInput,
  StarRate: AntdFormStarRate,
  CopyButton: AntdFormCopyButton,
  AutoComplete: AntdFormAutoComplete,
};
